import React from 'react';

import Footer from '../../components/Footer';
import TopNav from '../../components/TopNav';
import EngageBand from './components/EngageBand';
import FAQ from './components/FAQ';
import Hero from './components/Hero';
import LogoWall from './components/LogoWall';
import ProofBand from './components/ProofBand';
import SolutionsGrid from './components/SolutionsGrid';

import styles from '../../styles.module.css';

// Head metadata, the schema.org graph, sitemap.xml and llms.txt for this page
// all live in ./seo.ts and ./llms.ts as plain data, and are emitted at build
// time by scripts/prerender.mjs — not rendered by this component. See the note
// at the top of seo.ts for why.
//
// Still outstanding: an og:image asset (needs design) — see
// specs/functionality/RAAS_LANDING_SEO.md.
const RaaSLanding: React.FC = () => (
  <div className={styles.page}>
    <TopNav />
    <main>
      <Hero />
      <LogoWall />
      <SolutionsGrid />
      <EngageBand />
      <ProofBand />
      <FAQ />
    </main>
    <Footer />
  </div>
);

export default RaaSLanding;
